import { professionalStatusSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { getDefaultProfessionalStatusData } from '../utils/getDefaultProfessionalStatusData';
export const professionalStatusEntityName = 'professionalStatus';
export const professionalStatusColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { displayOrder: {
        type: 'number',
    }, occupationGroupIds: {
        type: 'string-array-required',
    }, type: {
        type: 'string-required',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineProfessionalStatusClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 2,
            columns: professionalStatusColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (_context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { displayOrder: params.data.displayOrder, type: params.data.type, occupationGroupIds: params.data.occupationGroupIds, search: [params.data.name, params.data.status, params.data.type].join(' ') });
            },
            onAnonymousAuthList: (_appState, response) => response,
            onAuthPost: (_appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: getDefaultProfessionalStatusData,
        defaultNameChanges: [
            {
                from: 'Non-Licensed and Retired Less than 10 Years',
                to: 'Non-Licensed and Retired for Less than 10 Years',
            },
            {
                from: 'Non-Licensed and Retired More than 10 Years',
                to: 'Non-Licensed and Retired for More than 10 Years',
            },
            {
                from: 'Non-Licensed and Retired for Less than 10 Years',
                to: 'Non-Licensed and Retired for Less Than 10 Years',
            },
            {
                from: 'Non-Licensed and Retired for More than 10 Years',
                to: 'Non-Licensed and Retired for More Than 10 Years',
            },
            {
                from: 'Licensed/Certified and Inactive for Less than 5 Years',
                to: 'Licensed/Certified and Inactive for Less Than 5 Years',
            },
            {
                from: 'Licensed/Certified and Inactive for More than 5 Years',
                to: 'Licensed/Certified and Inactive for More Than 5 Years',
            },
        ],
        publicData: [
            {
                mapValue: (row) => ({
                    value: row.id,
                    label: row.columns.name,
                    type: row.columns.type,
                    occupationGroupIds: row.columns.occupationGroupIds,
                    displayOrder: row.columns.displayOrder,
                }),
            },
        ],
    }, professionalStatusSchema);
}
